module.exports = __webpack_public_path__ + "img/undraw_file_analysis_8k9b.044e484d.png";